import { useTranslation } from 'react-i18next';

import { useNavigator } from '@/shared/navigation/react/useNavigator';
import { EntityEditLink } from '../../components/EntityEditLink';
import { productDetailAgenda } from '../detail/productDetailAgenda';

interface ProductLinkProps {
  /** Id produktu — jediný povinný parametr detailu produktu. */
  productId: string;
  /** Zobrazený text produktu (např. „kód · název"). */
  children: React.ReactNode;
}

/** Text produktu s editačním tlačítkem, které otevře detail produktu. */
export function ProductLink({ productId, children }: ProductLinkProps) {
  const { t } = useTranslation('venua-planner');
  const navigator = useNavigator();
  return (
    <EntityEditLink
      editLabel={t('actions.editProduct')}
      onEdit={() => void navigator.openModal(productDetailAgenda, { productId })}
    >
      {children}
    </EntityEditLink>
  );
}
